import { h } from 'vue'
import {
  ConfigProvider,
  Layout,
  Input,
  InputNumber,
  Button,
  Switch,
  Radio,
  Checkbox,
  Select,
  TreeSelect,
  Card,
  Form,
  Row,
  Col,
  Modal,
  Table,
  Tabs,
  Badge,
  Popover,
  Dropdown,
  List,
  Avatar,
  Empty,
  Breadcrumb,
  Steps,
  Spin,
  Menu,
  Drawer,
  Tooltip,
  Alert,
  Tag,
  Divider,
  DatePicker,
  TimePicker,
  Upload,
  Progress,
  Skeleton,
  Popconfirm,
  Pagination,
  PageHeader,
  Result,
  Statistic,
  Descriptions,
  message,
  notification,
  Space,
  Tree,
  Carousel,
} from 'ant-design-vue'
import * as Icons from '@ant-design/icons-vue'

import VueCropper from 'vue-cropper'
import Dialog from '@/components/Dialog'
import MultiTab from '@/components/MultiTab'
import PageLoading from '@/components/PageLoading'
import PermissionHelper from '@/core/permission/permission'
import VueClipboard from 'vue-clipboard2'
import setupActionDirective from './directives/action'

export function setupAntd(app) {
  app.use(ConfigProvider)
  app.use(Layout)
  app.use(Input)
  app.use(InputNumber)
  app.use(Button)
  app.use(Switch)
  app.use(Radio)
  app.use(Checkbox)
  app.use(Select)
  app.use(TreeSelect)
  app.use(Card)
  app.use(Form)
  app.use(Row)
  app.use(Col)
  app.use(Modal)
  app.use(Table)
  app.use(Tabs)
  app.use(Badge)
  app.use(Popover)
  app.use(Dropdown)
  app.use(List)
  app.use(Avatar)
  app.use(Breadcrumb)
  app.use(Steps)
  app.use(Spin)
  app.use(Menu)
  app.use(Drawer)
  app.use(Tooltip)
  app.use(Alert)
  app.use(Tag)
  app.use(Divider)
  app.use(DatePicker)
  app.use(TimePicker)
  app.use(Upload)
  app.use(Progress)
  app.use(Skeleton)
  app.use(Popconfirm)
  app.use(Pagination)
  app.use(PageHeader)
  app.use(Result)
  app.use(Statistic)
  app.use(Descriptions)
  app.use(Space)
  app.use(Tree)
  app.use(Carousel)
  app.use(VueClipboard)
  app.use(Empty)

  // register all icons globally for compatibility
  Object.keys(Icons).forEach((key) => {
    app.component(key, Icons[key])
  })

  // 注册 a-icon 兼容组件，支持 type 属性
  app.component('a-icon', {
    name: 'AIcon',
    props: {
      type: String,
      component: [Object, Function, String],
    },
    setup(props, { attrs }) {
      return () => {
        if (props.component) {
          // 如果 component 是字符串（SVG 路径或 URL），渲染为 img 标签
          if (typeof props.component === 'string') {
            // 检查是否是 URL 或路径
            if (props.component.startsWith('/') || props.component.startsWith('http://') || props.component.startsWith('https://') || props.component.includes('.')) {
              return h('img', {
                src: props.component,
                style: {
                  width: attrs.style?.fontSize || '1em',
                  height: attrs.style?.fontSize || '1em',
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  ...(attrs.style || {}),
                },
                ...Object.keys(attrs).reduce((acc, key) => {
                  if (key !== 'style') {
                    acc[key] = attrs[key]
                  }
                  return acc
                }, {}),
              })
            }
          }
          // 如果 component 是组件对象或函数，直接渲染
          if (typeof props.component === 'object' || typeof props.component === 'function') {
            // 检查是否是 Vue 组件（有 render 函数或 setup 函数）
            if (props.component && (props.component.render || props.component.setup || typeof props.component === 'function')) {
              return h(props.component, attrs)
            }
            // 如果是普通对象，可能是一个配置对象，尝试渲染
            return h(props.component, attrs)
          }
        }
        if (props.type) {
          // 尝试从 Icons 中查找对应的图标组件
          const iconName = props.type
          const iconVariants = [
            iconName,
            iconName.charAt(0).toUpperCase() + iconName.slice(1) + 'Outlined',
            iconName + 'Outlined',
            iconName.charAt(0).toUpperCase() + iconName.slice(1),
          ]
          
          for (const variant of iconVariants) {
            if (Icons[variant]) {
              return h(Icons[variant], attrs)
            }
          }
          
          // 如果找不到，返回一个占位符
          return h('span', { style: { display: 'inline-block', width: '1em', height: '1em' } }, '?')
        }
        return null
      }
    },
  })

  app.config.globalProperties.$confirm = Modal.confirm
  app.config.globalProperties.$message = message
  app.config.globalProperties.$notification = notification
  app.config.globalProperties.$info = Modal.info
  app.config.globalProperties.$success = Modal.success
  app.config.globalProperties.$error = Modal.error
  app.config.globalProperties.$warning = Modal.warning

  app.use(Dialog) // this.$dialog func
  app.use(MultiTab)
  app.use(PageLoading)
  app.use(PermissionHelper)
  app.use(VueCropper)
  
  // 注册 action 指令
  setupActionDirective(app)

  if (process.env.NODE_ENV !== 'production') {
    console.warn('[antd-pro] NOTICE: Antd use lazy-load.')
  }
}
